import { supabase } from '@/core/database/supabase';
import type { ConstructionVariation } from '../types/construction-boq.types';

export const ConstructionVariationsService = {
  async getVariations(boqId: string) {
    const { data, error } = await supabase
      .from('construction_variations')
      .select(`
        *,
        project:projects(id, name),
        boq:construction_boqs(id, boq_name)
      `)
      .eq('boq_id', boqId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as ConstructionVariation[];
  },

  async createVariation(data: Partial<ConstructionVariation>) {
    const { data: result, error } = await supabase
      .from('construction_variations')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionVariation;
  }
};
